import { ObservableArray, View } from "binder"
import { Item, MacAddressManipulationViewModel } from "./macAddressManipulation-viewModel"

export class MacAddressManipulationView extends View<MacAddressManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-27705B36-82E5-4D14-BB24-B12818BDBDB1"
    }
    loadHtml(): string {
        let element = require('./macAddressManipulation.html').default;
        let style = require('./macAddressManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<Item>) { this._items = v; } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;

}
